
// Libraries
var React = require('react');

// Components
var VideoMembershipOverlay = require('VideoMembershipOverlay/VideoMembershipOverlay');
var DialogButton = require('../Dialog/DialogButton');
var { getLoginStatus } = require('Logon/Logon');

// Styles
require('./VideoPlaceholder.scss');

// Assets
var playVideoIcon = require('./play-new.svg');
var playAudioIcon = require('./play-audio-new.svg');
var PlaceholderImg = require('images/blankImgPlaceholder.png');

class VideoPlaceholder extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoggedIn: false
		};
	}

	componentDidMount() {
		getLoginStatus()
			.then(result => {
				this.setState({ isLoggedIn: result.isLoggedIn });
			})
			.catch(err => {
				console.error('Login status fetch failed:', err);
			});
	}


	render() {
		const videoType = this.props.type ? this.props.type : 'media';
		const accessibleText = this.props.caption + ' (' + videoType.toLowerCase() + ')';
		const icon = this.props.type === 'VIDEO' ? (<img src={playVideoIcon} alt="" />) : (<img src={PlaceholderImg} data-src={playAudioIcon} alt="" />);
		const dialogName = 'dialog-video-member-modal';

		const renderDialog = this.props.membershipTier === 'Member' && !this.state.isLoggedIn;

		const thumbnailMarkup = this.props.thumbnail ? (
			<div
				className="VideoPlaceholder__image"
				data-bg={this.props.thumbnail.smallUrlWebP + '*,*' + this.props.thumbnail.mediumUrlWebP + '*,*' + this.props.thumbnail.largeUrlWebP + '*,*' + this.props.thumbnail.extraLargeUrlWebP}
				ref={(placeholder) => { this.placeholder = placeholder }}
			/>
		) : (
			<div className="VideoPlaceholder__image" />
		);

		const iconMarkup = (
			<span className="VideoPlaceholder__icon">
				{icon}
			</span>
		);

		const contents = (
			<VideoMembershipOverlay membershipTier={this.props.membershipTier}>
				{thumbnailMarkup}
				{iconMarkup}
			</VideoMembershipOverlay>
		);

		if (this.props.appDeepLink) { //Prioritise app deeplink - if this exists we want to use it over the login modal

			return (
				<a href={this.props.appDeepLink} className="VideoPlaceholder VideoPlaceholder--with-overlay" rel="noreferrer noopener" aria-label={"Open " + accessibleText}>
					{contents}
				</a>
			)

		}

		if (renderDialog) {

			return(
				<div>
					<div className="VideoPlaceholder VideoPlaceholder--with-overlay">{contents}</div>
					<DialogButton name={dialogName} additionalClass="Video__dialog-button">
						<span className="u-visually-hidden">Sign up or sign in to watch this video</span>
					</DialogButton>
				</div>
			)

		}

		if (this.props.externalLink) {

			return(
				<a href={this.props.externalLink} className="VideoPlaceholder VideoPlaceholder--with-overlay" rel="noreferrer noopener" target="_blank" aria-label={"Open " + accessibleText}>
					{contents}
				</a>
			)

		}

		return (
			<div>
				<div className="VideoPlaceholder VideoPlaceholder--with-overlay">{contents}</div>
				<button type="button" onClick={this.props.playVideo} className="Video__play-button">
					<span className="u-visually-hidden">Play {accessibleText}</span>
				</button>
			</div>
		)
	}
}

module.exports = VideoPlaceholder;



// WEBPACK FOOTER //
// ./src/components/Video/VideoPlaceholder.js